import { useNavigate } from "react-router-dom";
import classes from "./PurchaseOptions.module.css";


const PaymentCompleted = ({}) => {

  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center mt-5">
      <div className={`d-flex flex-column align-items-center ${classes.boxedContainer}`}>
        <img src="/icons/check-icon.svg" alt="Success" />
        <p>
          You successfully purchased a Challenge account
        </p>
        <span onClick={() => navigate("/trading")} role="button" tabIndex={0}>
          Back to home
        </span>
      </div>
    </div>
  )
};

export default PaymentCompleted;